document.addEventListener('DOMContentLoaded', function () {
  /* v14.2: enlaces internos a páginas que aún no existen en Shopify -> sin 404 */
  (function () {
    var P = window.CUSTOMLY_PAGES || {};
    var CONVERSION = { 'pide-tu-diseno': 1, 'crea-tu-sudadera': 1 };
    var inEditor = window.Shopify && window.Shopify.designMode;
    if (inEditor) return;
    document.querySelectorAll('a[href*="/pages/"]').forEach(function (a) {
      var m = (a.getAttribute('href') || '').match(/^(?:https?:\/\/[^/]+)?\/pages\/([a-z0-9-]+)\/?(#.*)?$/i);
      if (!m || !(m[1] in P)) return;
      if (typeof P[m[1]] === 'string') {
        /* v14.3: la pagina existe con otra URL en la tienda (p. ej. inspiracion -> inspo) */
        if (P[m[1]] !== '/pages/' + m[1]) a.setAttribute('href', P[m[1]] + (m[2] || ''));
        return;
      }
      if (P[m[1]]) return;
      if (CONVERSION[m[1]]) {
        var onHome = location.pathname === '/' || location.pathname === '';
        a.setAttribute('href', (onHome ? '' : '/') + '#configurador');
        return;
      }
      if (a.classList.contains('btn')) { a.remove(); return; }
      var span = document.createElement('span');
      span.className = a.className;
      span.innerHTML = a.innerHTML;
      a.replaceWith(span);
    });
  })();
  // Menú móvil (v14: se cierra al navegar, con Escape y al volver a escritorio)
  var toggle = document.querySelector('.nav-toggle');
  var mobileNav = document.querySelector('.mobile-nav');
  if (toggle && mobileNav) {
    var setNav = function (open) {
      mobileNav.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú');
      document.body.classList.toggle('nav-open', open);
    };
    toggle.addEventListener('click', function () { setNav(!mobileNav.classList.contains('is-open')); });
    mobileNav.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { setNav(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) { setNav(false); toggle.focus(); } });
    window.addEventListener('resize', function () { if (window.innerWidth > 1240) setNav(false); });
  }

  // v14: barra de conversión móvil y burbuja de WhatsApp — se apartan cuando ya hay un formulario
  // o el configurador en pantalla (no tapan botones ni duplican la llamada a la acción).
  if ('IntersectionObserver' in window) {
    var visibles = new Set();
    var sync = function () {
      var czOn = false, formOn = false;
      visibles.forEach(function (el) {
        if (el.hasAttribute('data-configurator')) czOn = true; else formOn = true;
      });
      document.body.classList.toggle('cz-in-view', czOn);
      document.body.classList.toggle('m-cta-off', czOn || formOn);
    };
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) visibles.add(en.target); else visibles.delete(en.target); });
      sync();
    }, { rootMargin: '-15% 0px -15% 0px' });
    document.querySelectorAll('[data-configurator],[data-quote],.site-footer').forEach(function (el) { io.observe(el); });

    // Vídeos: solo se reproducen mientras se ven (ahorra datos y batería en móvil)
    /* v14.2: son bucles silenciosos tipo GIF -> se reproducen siempre. Antes se bloqueaban con "reducir movimiento"
       (activo en muchos Windows con las animaciones desactivadas) y parecia que los videos no funcionaban. */
    var reduce = false;
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting && !reduce) {
          if (v.preload === 'none') v.preload = 'auto';
          v.muted = true; v.autoplay = true;
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else { v.pause(); }
      });
    }, { threshold: 0.25 });
    document.querySelectorAll('video[data-autoplay-video]').forEach(function (v) {
      /* v14.1: comportamiento de GIF — siempre sin sonido, inline, en bucle y sin controles */
      v.muted = true; v.defaultMuted = true; v.setAttribute('muted', ''); v.volume = 0;
      v.loop = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.controls = false;
      v.removeAttribute('autoplay'); vio.observe(v);
    });
    /* al volver a la pestaña, el navegador no reanuda solo los vídeos sin audio que pausó en segundo plano */
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState !== 'visible' || reduce) return;
      document.querySelectorAll('video[data-autoplay-video]').forEach(function (v) {
        var r = v.getBoundingClientRect();
        if (r.bottom > 0 && r.top < window.innerHeight && r.right > 0 && r.left < window.innerWidth && v.paused) {
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        }
      });
    });
  }

  // Sliders (galería)
  document.querySelectorAll('[data-slider-wrap]').forEach(function (wrap) {
    var track = wrap.querySelector('[data-slider]');
    if (!track) return;
    var step = function () { return track.clientWidth * 0.7; };
    var prev = wrap.querySelector('[data-slider-prev]');
    var next = wrap.querySelector('[data-slider-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    /* v14.2: flechas deshabilitadas en los extremos y ocultas si no hay nada que desplazar */
    var syncNav = function () {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      var nav = (prev || next) && (prev || next).parentElement;
      if (nav) nav.classList.toggle('is-static', max <= 0);
    };
    track.addEventListener('scroll', function () { window.requestAnimationFrame(syncNav); }, { passive: true });
    window.addEventListener('resize', syncNav);
    syncNav();
  });

  // Copiar al portapapeles
  document.querySelectorAll('[data-copy]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var text = btn.getAttribute('data-copy');
      var done = function () {
        var original = btn.textContent;
        btn.textContent = 'Copiado';
        setTimeout(function () { btn.textContent = original; }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done).catch(done);
      } else { done(); }
    });
  });

  // Localizador de pedidos
  document.querySelectorAll('[data-localizador]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var code = (form.querySelector('input[name=code]').value || '').trim();
      if (!code) return;
      var base = form.getAttribute('data-base');
      var wa = form.getAttribute('data-wa');
      var msg = form.parentElement.querySelector('[data-loc-msg]');
      var btn = form.querySelector('button[type=submit],button:not([type])');
      function toWa() {
        if (msg) msg.classList.add('is-visible');
        if (wa) window.open(wa + '?text=' + encodeURIComponent('¡Hola! ¿Me decís por dónde va mi pedido? Código: ' + code), '_blank');
      }
      if (!base) { toWa(); return; }
      /* VERSION_CARLOS: el codigo lleva a la pagina del grupo (/products/grupo-<codigo>) con su estado;
         si no existe, se cae a WhatsApp como antes */
      var url = base + encodeURIComponent(code.toLowerCase().replace(/[^a-z0-9-]/g, ''));
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
      fetch(url, { method: 'HEAD', credentials: 'same-origin' }).then(function (r) {
        if (r.ok) window.location.href = url; else toWa();
      }).catch(toWa).then(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
    });
  });

});
